import React from 'react';

interface ImagePlaceholderProps {
  aspectRatio?: string;
  label?: string;
  className?: string;
  width?: number;
  height?: number;
}

export default function ImagePlaceholder({
  aspectRatio = '4/3',
  label = 'REAL WILLOW IMAGE REQUIRED',
  className = '',
  width,
  height,
}: ImagePlaceholderProps) {
  const style: React.CSSProperties = {};
  if (width) style.width = width;
  if (height) style.height = height;
  if (!height) style.aspectRatio = aspectRatio.replace('/', ' / ');

  return (
    <div
      className={`image-placeholder-bg flex flex-col items-center justify-center w-full ${className}`}
      style={style}
      role="img"
      aria-label={label}
    >
      <div className="flex flex-col items-center gap-2 p-4 text-center">
        {/* Camera icon */}
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
          className="text-muted-foreground opacity-50"
        >
          <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" />
          <circle cx="12" cy="13" r="4" />
        </svg>
        <span className="text-xs font-medium tracking-widest uppercase text-muted-foreground opacity-60">
          {label}
        </span>
      </div>
    </div>
  );
}